class AltStorage {

    private data:{[key:string]:string}

    constructor () 
    {
        this.data = {};
    }

    removeItem(key:string):void 
    {
        delete this.data[key];
    }

    getItem(key:string):string 
    {
        if (typeof (this.data[key]) != 'undefined') return this.data[key];
        return "";
    }

    setItem(key:string, value:string):void 
    {
        this.data[key] = value;
    }
};

export default AltStorage;